// Estado do módulo Gestão Fee Fixo.
// Cada slice de dados segue o padrão { data, loading, lastUpdate }; a camada de
// API (api/apiFeeFixo*) é quem carrega + armazena. Actions só fazem commit —
// nunca chamam API.

import { lerCodigoClienteAtivo } from '@modules/fee-fixo/utils/clienteAtivoStorage'

const slice = (data) => ({ loading: false, lastUpdate: null, data })

export default {
  // Dashboard (cards + clusters + tabela de clientes). data é objeto.
  dashboard: slice({
    patrimonio_total: 0,
    patrimonio_liquido: 0,
    receita_atual: 0,
    receita_projetada: 0,
    pl_fee_fixo: 0,
    total_clientes: 0,
    clientes_fee_fixo: 0,
    clusters_patrimonio: [],
    clusters_elegibilidade: [],
    clientes: [],
  }),

  // Clientes do BI por visão — 2 slices independentes (cada visão cacheada para
  // que alternar Minha Carteira / Escritório seja instantâneo).
  clientesProfissional: slice([]),
  clientesEscritorio: slice([]),
  // Visão ativa do seletor/toggle (estado de UI, não é dado de API).
  clientesVisao: 'profissional',

  // Simulação — histórico de análises persistidas. data é array.
  analises: slice([]),

  // Cliente ativo do módulo (isolado do resto da plataforma) — nasceu só da
  // Simulação, e desde o redesign 07/08/2026 (7ª rodada) o Ensaio também lê
  // daqui, em vez de `:codigoCliente` na rota (ativar um cliente numa tela
  // deixa ele pré-selecionado na outra). Só o código persiste em
  // localStorage (reidrata no boot); nome/detalhe são refetchados via API.
  clienteAtivo: {
    codigo: lerCodigoClienteAtivo(),
    nome: '',
    detalhe: null,
  },
}
